"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityConnectionsSummary = exports.EntityConnectionsSummaryDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var lodash_1 = require("lodash");
var entity_count_label_1 = require("./entity-count-label");
var number_bubble_1 = require("../elements/number-bubble");
var router_1 = require("@reach/router");
var entity_connections_link_1 = require("./entity-connections-link");
exports.EntityConnectionsSummaryDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var CountLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    padding: ", " ", ";\n    background: ", ";\n    margin-left: ", ";\n    font-weight: 400;\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "], ["\n    display: block;\n    padding: ", " ", ";\n    background: ", ";\n    margin-left: ", ";\n    font-weight: 400;\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(10), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'))
});
var CountLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 400;\n    color: inherit;\n  "], ["\n    font-weight: 400;\n    color: inherit;\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n    text-decoration: none;\n    margin: 0;\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    align-items: center;\n    display: flex;\n    text-decoration: none;\n    margin: 0;\n  "])), theme_1.theme.FONT_SIZE(15))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n  "])))
});
var MapLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500; \n  "], ["\n    font-size: ", ";\n    font-weight: 500; \n  "])), theme_1.theme.FONT_SIZE(14))
});
var TotalStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-right: ", ";\n\n  "], ["\n    margin-right: ", ";\n\n  "])), theme_1.theme.UNIT(2))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    list-style: none;\n    margin: 0;\n    padding-left: ", ";\n    margin-left: ", ";\n    font-size: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "], ["\n    ", ";\n    list-style: none;\n    margin: 0;\n    padding-left: ", ";\n    margin-left: ", ";\n    font-size: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "])), theme_1.theme.DOT_BG('v'), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2.5), theme_1.theme.FONT_SIZE(15))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    background-position: left center;\n    margin: ", " 0;\n  "], ["\n    ", ";\n    background-position: left center;\n    margin: ", " 0;\n  "])), theme_1.theme.DOT_BG('h'), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled_components_1.default.header(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  MapLink: (0, styled_components_1.default)(entity_connections_link_1.EntityConnectionsLink)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), MapLinkStyles),
  Title: styled_components_1.default.h1(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Total: (0, styled_components_1.default)(number_bubble_1.NumberBubble)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TotalStyles),
  Body: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Items: styled_components_1.default.ul(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.li(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  CountLink: (0, styled_components_1.default)(router_1.Link)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), CountLinkStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityCountLabel)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), CountLabelStyles)
};
var EntityConnectionsSummary = function (props) {
  var className = props.className,
    entity = props.entity;
  var entityDict = entity;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var children = (0, use_app_screen_1.useAppScreen)().detailsChildren;
  var t = (0, use_lang_1.useLang)();
  var counts = children.reduce(function (acc, child) {
    if (child.entityTypeName) {
      var isMultiple = (0, lodash_1.includes)(['linkedMultiple', 'list'], child.type);
      var value = entityDict[isMultiple ? child.countFieldName : child.fieldName];
      if (value) {
        var count = isMultiple ? value.length || 0 : 1;
        if (count) {
          acc.push({
            path: child.path,
            entityTypeName: child.entityTypeName,
            count: count
          });
        }
      }
    }
    return acc;
  }, []);
  if (!counts.length) {
    return null;
  }
  var total = (0, lodash_1.sumBy)(counts, 'count');
  var connectionsLabel = t(total === 1 ? 'Current Connection' : 'Current Connections');
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Header, null, react_1.default.createElement(My.Title, null, react_1.default.createElement(My.Total, {
    size: "tiny"
  }, total), connectionsLabel), definition.useConnections && !!total && react_1.default.createElement(My.MapLink, {
    entity: entity
  }, t('View Connections Map'))), react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Items, null, counts.map(function (ec, index) {
    return react_1.default.createElement(My.Item, {
      key: index
    }, react_1.default.createElement(My.CountLink, {
      to: definition.to(entity.slug, ec.path)
    }, react_1.default.createElement(My.CountLabel, {
      iconSize: 24,
      entityTypeName: ec.entityTypeName,
      count: ec.count
    })));
  }))));
};
exports.EntityConnectionsSummary = EntityConnectionsSummary;
exports.EntityConnectionsSummary.defaultProps = exports.EntityConnectionsSummaryDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;